import React from "react";
import { Chrome } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
export default function VideoUpload() {
  return <section data-section-id="256369" id="video-upload" className="w-full bg-background text-foreground">
      <div className="relative my-6">
        <div className="absolute inset-0 flex items-center">
          <Separator className="w-full border-border" />
        </div>
        <div className="relative flex justify-center text-xs uppercase">
          <span className="bg-background px-2 text-muted-foreground font-default tracking-wider">Opplev xora</span>
        </div>
      </div>

      <div className="mb-8 text-center">
        <h2 className="font-bold text-foreground mb-2 !text-5xl">SE DEMO</h2>
        <p className="text-muted-foreground text-sm">Kommer snart...</p>
      </div>

      
    </section>;
}